// extracted by mini-css-extract-plugin
export var visibleStyle = "FlagDropdown-module--visibleStyle--fI9rA";
export var currencyButton = "FlagDropdown-module--currencyButton--vzGBJ";
export var labelContainer = "FlagDropdown-module--labelContainer--2pZlG";
export var label = "FlagDropdown-module--label--2_VHK";
export var text = "FlagDropdown-module--text--2v50M";
export var message = "FlagDropdown-module--message--24v_y";
export var arrow = "FlagDropdown-module--arrow--1aExc";